<div *ngIf="viewData$ |async as viewdata" class="swmimlane-taskboard">
  <div cdkDropListGroup class="taskboard-swimlane-container">
    <mat-accordion multi>
      <app-taskboard-swimlane *ngFor="let map of viewdata.maps" [isInteractive]="isInteractive"
                              [keyResultList]="viewdata.keyResults" [keyResult]="map.keyResult"
                              [tasksForStates]="map.statesWithTasks"></app-taskboard-swimlane>
    </mat-accordion>
  </div>
</div>
